import React from "react";

const AdhaarCard = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            fill={fill}
            d="M2 7.438C2 6.643 2.651 6 3.455 6h29.09C33.35 6 34 6.644 34 7.438v20.125c0 .793-.651 1.437-1.455 1.437H3.455A1.446 1.446 0 0 1 2 27.562V7.438Zm17.454 4.312v2.875h8.728V11.75h-8.727Zm7.273 5.75h-7.273v2.875h7.273V17.5Zm-10.909-2.875c0-1.985-1.628-3.594-3.636-3.594s-3.637 1.61-3.637 3.594c0 1.985 1.629 3.594 3.637 3.594s3.636-1.61 3.636-3.594Zm-3.636 5.031c-2.812 0-5.091 2.253-5.091 5.032h10.182c0-2.78-2.28-5.032-5.091-5.032Z"
        />
    </svg>
);

export default AdhaarCard;